// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__15VN1","legacyBtn":"MutateMid_legacyBtn__Os0AJ"};